export enum EnumTpCarteira {
    CobrancaSimples = 1,
    CobrancaVinculada = 2
}